"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(portalId) {
  return ['portal', portalId];
};

exports["default"] = _default;